import { StepChildProps } from 'sos-common/js/components//WizardStepper/WizardStepper.types';
import { translateFunc, makeTranslator } from 'sos-common/js/utils/translations';
import { OmbudFormStore } from '../models/OmbudStore';
import React from 'react';
import { connect } from 'react-redux';

export interface Step4Props extends StepChildProps {
  Translate?: translateFunc;
}

export class Step4 extends React.Component<Step4Props, {}> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  public getTitle = () => 'Ansökan inskickad';

  public componentDidMount() {
    this.props.stepState.isThankYouPage = true;
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  public render() {
    const { Translate } = this.props;

    return (
      <div id="step4" tabIndex={-1}>
        <h2>{this.props.Translate('|OmbudsansokanForm|confirmationHeading')}</h2>
        <p>{this.props.Translate('|OmbudsansokanForm|confirmationBody1')}</p>
        <p>{this.props.Translate('|OmbudsansokanForm|confirmationBody2')}</p>
      </div>
    );
  }
}

const mapState2Props = (state: OmbudFormStore) => {
  const { globals } = state;
  const { translations } = globals;
  return {
    Translate: makeTranslator(translations),
  } as Partial<Step4Props>;
};

const StepFour = connect(mapState2Props, {})(Step4);
export { StepFour };
